import script from "./testimonialSection.vue?vue&type=script&setup=true&lang=js"
export * from "./testimonialSection.vue?vue&type=script&setup=true&lang=js"

import "./testimonialSection.vue?vue&type=style&index=0&id=5bc87902&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc87902"]])

export default __exports__